export default __webpack_public_path__ + "static/media/email_asset.0339f132.png";